<template>
  <div id="bottom1" class="box">
    <div class="up">
      <div class="item bg-color-black">
        <div class="d-flex pt-2 pl-2">
        <span>
          <!-- <icon name="chart-area" class="text-icon"></icon> -->
        </span>
          <div class="d-flex">
            <span class="fs-xl text mx-2">体检次数时间变化</span>
          </div>
        </div>
        <div class="d-flex jc-center body-box">
          <Chart :cdata="cdata"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from '_c/echart/bottom/bottomRightChart/chart'
import {getTimeDay} from "@/api/area/bottom1";

export default {
  data() {
    return {
      drawTiming: null,
      cdata: {
        year: null,
        weekCategory: [],
        maxData: 0,
        weekMaxData: [],
        weekLineData: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
      }
    }
  },
  components: {
    Chart,
  },
  mounted() {
    this.getData();
  },
  watch: {
    immediate: true,
    deep: true
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      // 体检次数排行榜
      getTimeDay().then((res) => {
        if (res.code === "0") {
          let day = [];
          let ret = [];
          let time = {};
          let max = 0;
          res.data.forEach((item) => {
            this.$set(time, item.day, item.time);
            if (max < item.time) {
              max = item.time;
            }
          });
          for (var i = 30; i > -1; i--) {
            let dayStr = this.getDay(-i);
            day.push(dayStr);
            let value = time[dayStr];
            if (typeof value === "undefined") {
              ret.push(0);
            } else {
              ret.push(value);
            }

          }
          this.cdata.weekLineData = ret;
          this.cdata.weekCategory = day;
          this.cdata.maxData = max;
          this.cdata.weekMaxData.push(max);
          this.cdata = {...this.cdata}
        }
      });
    },

    /**
     * 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
     * @param day
     * @returns {string}
     */
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      // var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      // return tYear + "-" + tMonth + "-" + tDate;
      return tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length === 1) {
        m = "0" + month;
      }
      return m;
    },


    // drawTimingFn () {
    //   this.setData();
    //   this.drawTiming = setInterval(() => {
    //     this.setData();
    //   }, 6000);
    // },
    // setData () {
    //
    //   // 清空轮询数据
    //   this.cdata.weekCategory = [];
    //   this.cdata.weekMaxData = [];
    //   this.cdata.weekLineData = [];
    //   this.cdata.radarData = [];
    //   this.cdata.radarDataAvg = [];
    //
    //   let dateBase = new Date();
    //   this.cdata.year = dateBase.getFullYear();
    //   // 周数据
    //   for (let i = 0; i < 7; i++) {
    //     // 日期
    //     let date = new Date();
    //     this.cdata.weekCategory.unshift([date.getMonth() + 1, date.getDate()-i].join("/"));
    //
    //     // 折线图数据
    //     this.cdata.weekMaxData.push(this.cdata.maxData);
    //     let distance = Math.round(Math.random() * 11000 + 500);
    //     this.cdata.weekLineData.push(distance);
    //
    //     // // 雷达图数据
    //     // // 我的指标
    //     // let averageSpeed = +(Math.random() * 5 + 3).toFixed(3);
    //     // let maxSpeed = averageSpeed + +(Math.random() * 3).toFixed(2);
    //     // let hour = +(distance / 1000 / averageSpeed).toFixed(1);
    //     // let radarDayData = [distance, averageSpeed, maxSpeed, hour];
    //     // this.cdata.radarData.unshift(radarDayData);
    //
    //     // // 平均指标
    //     // let distanceAvg = Math.round(Math.random() * 8000 + 4000);
    //     // let averageSpeedAvg = +(Math.random() * 4 + 4).toFixed(3);
    //     // let maxSpeedAvg = averageSpeedAvg + +(Math.random() * 2).toFixed(2);
    //     // let hourAvg = +(distance / 1000 / averageSpeed).toFixed(1);
    //     // let radarDayDataAvg = [
    //     //   distanceAvg,
    //     //   averageSpeedAvg,
    //     //   maxSpeedAvg,
    //     //   hourAvg
    //     // ];
    //     let radarDayDataAvg =[distance]
    //     this.cdata.radarDataAvg.unshift(radarDayDataAvg);
    //   }
    //
    // }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/box';
//
#bottom1 {
  padding: 0%;

}
</style>
